import { render, staticRenderFns } from "./PendencyGenerationNotifyDropdown.vue?vue&type=template&id=fad7147a"
import script from "./PendencyGenerationNotifyDropdown.vue?vue&type=script&lang=js"
export * from "./PendencyGenerationNotifyDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports